import * as React from 'react';
import { classList } from '../../../utils/string.ts';

/**
 * A full screen scroll container with fixed position.
 * The scroll bar will be at the very right side of the screen, even though the content doesn't have to be that wide.
 * Refer high modals as an example.
 */
export const BackdropScrollContainer = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>((props, ref) => {
  const { ...htmlAttributes } = props;

  return (
    <div
      {...htmlAttributes}
      className={classList(
        'fixed inset-0 z-(--z-index-backdrop) overflow-x-hidden overflow-y-auto',
        props.className
      )}
      ref={ref}
    >
      {props.children}
    </div>
  );
});
